import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export default class Advanced extends React.Component {
  constructor() {
    super();

    this.state = {
      request: '',
    };

    this.onRequestChange = this.onRequestChange.bind(this);
    this.onRequestAdd = this.onRequestAdd.bind(this);
  }

  onRequestChange(event) {
    this.setState({
      request: event.target.value,
    });
  }

  onRequestAdd() {
    const requestText = this.state.request;

    if (requestText) {
      this.setState(
        {
          request: '',
        },
        () => {
          const currentTimestamp = moment()
            .utc()
            .valueOf();

          this.props.onRequestAdd({
            feature_request: requestText,
            request_status: [{ status: 'PENDING', timestamp: currentTimestamp }],
            timestamp: currentTimestamp,
          });
        },
      );
    }
  }

  render() {
    const { details, disabled, preferences } = this.props;
    const customRequests = Object.keys(details.custom_requests || {}).map((key) => {
      return Object.assign({ key }, details.custom_requests[key]);
    });

    const pendingRequests = customRequests.filter((item) => {
      const lastStatus = item.request_status[item.request_status.length - 1];

      return lastStatus.status === 'PENDING';
    });

    const approvedRequests = customRequests.filter((item) => {
      const lastStatus = item.request_status[item.request_status.length - 1];

      return lastStatus.status === 'APPROVED';
    });

    return (
      <div className="advanced">
        {approvedRequests.length ? (
          <div className="aadvanced--row">
            <p className="advanced__row__label">Approved customizations</p>
            <div className="advanced__row__input multi-check">
              <div className="list">
                {approvedRequests.map((item) => {
                  const lastStatus = item.request_status[item.request_status.length - 1];

                  return (
                    <div className="list-item" key={item.key}>
                      <div className="list-item__text">{item.feature_request}</div>
                      <div className="list-item__date">
                        {moment(item.timestamp).format('Do MMM, YYYY hh:mma')}
                      </div>
                      <div className="list-item__status">{lastStatus.status}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ) : (
          undefined
        )}

        {approvedRequests.length ? <div className="preferences--separator" /> : undefined}

        {pendingRequests.length ? (
          <div className="aadvanced--row">
            <p className="advanced__row__label">
              Pending requests
              <br />
              <span className="hint-text">
                Note: We might take upto 2 business days to approve your requests. In case a request
                is rejected we will send you an email with the reason.
              </span>
            </p>
            <div className="advanced__row__input multi-check">
              <div className="list">
                {pendingRequests.map((item) => {
                  const lastStatus = item.request_status[item.request_status.length - 1];

                  return (
                    <div className="list-item" key={item.key}>
                      <div className="list-item__text">{item.feature_request}</div>
                      <div className="list-item__date">
                        {moment(item.timestamp).format('Do MMM, YYYY hh:mma')}
                      </div>
                      <div className="list-item__status">{lastStatus.status}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ) : (
          undefined
        )}

        {pendingRequests.length ? <div className="preferences--separator" /> : undefined}

        <div className="aadvanced--row">
          <p className="advanced__row__label">
            <div className="bold-title">If you have any requirements specific to your business, let us know. </div>
            We&apos;ll get back in touch with you in 3-5 days
          </p>
          <div className="advanced__row__input">
            <textarea
              rows="3"
              placeholder=""
              name="customRequest[feature_request]"
              value={this.state.request}
              onChange={this.onRequestChange}
              disabled={disabled}
            />
            <button
              className="btn btn--primary btn--lg"
              type="button"
              onClick={this.onRequestAdd}
              disabled={disabled}
            >
              SEND REQUEST
            </button>
          </div>
        </div>
      </div>
    );
  }
}

Advanced.defaultProps = {
  onRequestAdd: () => {},
  details: {},
  disabled: false,
};

Advanced.propTypes = {
  onRequestAdd: PropTypes.func,
  details: PropTypes.shape(),
  disabled: PropTypes.bool,
};
